import { registerPlugin } from '@capacitor/core';

const Yoomoney = registerPlugin('Yoomoney');

export default Yoomoney;